import {
  COTIZADOR_GET_REPORT_FILE_BEGIN,
  COTIZADOR_GET_REPORT_FILE_SUCCESS,
  COTIZADOR_GET_REPORT_FILE_FAILURE
} from './constants'
import { BFFAgent } from '../../../common/BFFAgent'

export function getReportCotizador(fromDate, toDate) {
  return async (dispatch) => {
    dispatch({
      type: COTIZADOR_GET_REPORT_FILE_BEGIN
    })
    
    try {
      const res = await BFFAgent.Cotizador.generateExcel(fromDate, toDate)

      // TODO: maybe generate a helper function
      const link = document.createElement('a');
      link.href = res.downloadUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    
      dispatch({
          type: COTIZADOR_GET_REPORT_FILE_SUCCESS
      })
    }
    catch(err) {
      dispatch({
        type: COTIZADOR_GET_REPORT_FILE_FAILURE,
        data: { error: err },
      })
    }
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case COTIZADOR_GET_REPORT_FILE_BEGIN: 
      return {
        ...state,
        reportFileCotizadorPending: true,
        reportFileCotizadorError: null,
        reportFileCotizadorSuccess: false
      }
    case COTIZADOR_GET_REPORT_FILE_SUCCESS: 
      return {
        ...state,
        reportFileCotizadorSuccess: true,
        reportFileCotizadorPending: false,
        reportFileCotizadorError: null,
      }
    case COTIZADOR_GET_REPORT_FILE_FAILURE: 
      return {
        ...state,
        ...action.data,
        reportFileCotizadorError: action.data.error,
        reportFileCotizadorPending: false,
        reportFileCotizadorSuccess: false
      }
    default:
      return state
  }
}
